import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import uuid4 from 'rebook/apps/utils/random/uuid4';

import fixQueryString from 'rebook/apps/utils/urls/fixQueryString';
import DashboardBookList from 'rebook/apps/dashboard/components/DashboardBookList';
import DashboardBookListEmpty from 'rebook/apps/dashboard/components/DashboardBookListEmpty';
import * as DashboardBlockListActions from 'rebook/apps/dashboard/actions/dashboardBlockListActions';
import {
  DASHBOARD_BLOCK_SET_DATA,
} from 'rebook/apps/dashboard/constants';


class DashboardBookListBlock extends React.Component {
  constructor(props) {
    super(props);
    const { block } = props;
    this.bookLimit = 10;
    const blockId = `${block.id}-${block.type}`;

    this.state = {
      block,
      blockId,
    };
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  componentDidMount() {
    this.fetchBookList();
  }

  fetchBookList() {
    const { block: { resource_uri: resourceUri }, blockId } = this.state;
    const { dashboardBlockList, user } = this.props;

    if (dashboardBlockList[blockId]) {
      return null;
    }

    const url = fixQueryString(resourceUri, { limit: this.bookLimit });
    this.props.DashboardBlockListActions.fetchDashboardBlock(url, { apiVersion: 4 })
      .then(
        ({ data, dispatch }) => {
          // endpoint may return either plain list or paginated response
          const books = data.objects ? data.objects : data;

          if (resourceUri === '/api/reco/' && user) {
            books.push({
              type: 'fake',
              id: +(uuid4().replace(/\D/gi, '')),
            });
          }

          dispatch({
            type: DASHBOARD_BLOCK_SET_DATA,
            payload: {
              [blockId]: {
                books,
                bookCountTotal: data.meta ? data.meta.total_count : null,
              },
            },
          });
        }
      )
      .catch(
        ({ data, resp }) => {
          Raven.captureMessage('failed to fetch dashboard books due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
            },
          });
        }
      );
  }

  render() {
    const { block, blockId } = this.state;
    const { dashboardBlockList, itemKey } = this.props;

    const bookCount = get(dashboardBlockList[blockId], 'bookCountTotal', 0);

    const bookCountTitle = bookCount > this.bookLimit
      ? this.bookLimit
      : bookCount;

    return (
      get(dashboardBlockList[blockId], 'books.length', 0) !== 0
        ? (
          <DashboardBookList
            title={block.title}
            books={dashboardBlockList[blockId].books}
            bookCount={bookCountTitle}
            itemKey={itemKey} />
        )
        : <DashboardBookListEmpty />
    );
  };
}

const mapStateToProps = (state) => {
  return {
    dashboardBlockList: state.dashboardBlockList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    DashboardBlockListActions: bindActionCreators(DashboardBlockListActions, dispatch),
  };
};

DashboardBookListBlock.propTypes = {
  block: PropTypes.shape({
    title: PropTypes.string.isRequired,
    resource_uri: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBookListBlock);
